<script>
import { Radar, mixins } from 'vue-chartjs';
import TranslationMixin from '../../lib/TranslationMixin';

export default {
  extends: Radar,
  mixins: [mixins.reactiveProp, TranslationMixin],
  props: ['options'],
  mounted() {
    this.renderChart(this.translatedChartData, this.options);
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
    options() {
      this.$data._chart.update();
    },
  },
  computed: {
    translatedChartData() {
      const translated = { ...this.chartData };
      for (const [i, labels] of translated.labels.entries()) {
        for (const [j, label] of translated.labels[i].entries()) {
          translated.labels[i][j] = this.$t(
            translated.labels[i][j],
            translated.labels[i][j].toLowerCase().replace(/\s/, '-')
          );
        }
      }

      for (const [i, dataset] of translated.datasets.entries()) {
        translated.datasets[i].label = this.$t(
          translated.datasets[i].label,
          translated.datasets[i].label.toLowerCase().replace(/\s/, '-')
        );
      }

      return translated;
    },
  },
  methods: {
    getChartSettings() {
      const fillOptions = [
        { label: 'Yes', value: 'start' },
        { label: 'No', value: false },
      ];
      const lineStyleOptions = [
        { label: 'Solid', value: [] },
        { label: 'Dashed', value: [10, 10] },
        { label: 'Dotted', value: [5, 5] },
      ];
      const chartSettings = [];
      const tooltipSettings = {
        enabled: false,
      };
      const datasetSettings = [
        {
          title: 'Dataset settings',
          classes: 'grid colours',
          fields: [
            {
              type: 'radio',
              label: 'Fill',
              options: fillOptions,
              name: 'fill',
              model: 'fill',
            },
            {
              type: 'color',
              label: 'Fill colour',
              name: 'backgroundColor',
              model: 'backgroundColor',
            },
            {
              type: 'color',
              label: 'Line colour',
              name: 'borderColor',
              model: 'borderColor',
            },
            {
              type: 'select',
              label: 'Line style',
              options: lineStyleOptions,
              name: 'borderDash',
              model: 'borderDash',
            },
            {
              type: 'number',
              label: 'Tension',
              name: 'tension',
              model: 'tension',
            },
          ],
        },
      ];

      return {
        chart: chartSettings,
        dataset: datasetSettings,
        tooltips: tooltipSettings,
      };
    },
  },
};
</script>

<style></style>
